module.exports = __webpack_public_path__ + "img/wechat.03daf94b.png";